import { HOME_COPY } from "@/components/dashboard/home-copy";
import type { Box, BoxState } from "@/components/ui/box.schema";

/** CASE-041: an unresolved answer owns the hidden row's word before any kept draft. */
export function rowWorkState(box: Box | undefined): BoxState | null {
  if (!box || box.kind !== "task") return null;
  switch (box.result.state) {
    case "unknown": return { class: "failed", word: HOME_COPY.notConfirmed };
    case "partial": return { class: "waiting", word: HOME_COPY.partlyDone };
    case "refused": return { class: "failed", word: HOME_COPY.refused };
    default: return null;
  }
}
